/** Netlify Web Analytics treats server CDN hits like page views — there is no `track()` API yet.
 *  We GET unique `/__insights/...` URLs so interactions show up alongside real pages as extra paths.
 *  Requires the redirect in netlify.toml and Web Analytics enabled in the Netlify UI. */

function insightsEnabled() {
	if (typeof window === "undefined") return false;
	if (typeof process !== "undefined" && process.env.NODE_ENV !== "production")
		return false;
	const h = window.location.hostname;
	return h !== "localhost" && h !== "127.0.0.1";
}

/** Used to build readable path-safe labels from titles and hostnames */
export function sanitizeInsightSegment(segment) {
	return String(segment)
		.toLowerCase()
		.trim()
		.replace(/\s+/g, "-")
		.replace(/[^a-z0-9-]/g, "")
		.replace(/-+/g, "-")
		.replace(/^-|-$/g, "")
		.slice(0, 48) || "x";
}

/** @param {string} category e.g. "demo-play", "outbound-link", "mailto" */
/** @param {string} slug descriptive label slug */
export function reportNetlifyInsight(category, slug) {
	if (!insightsEnabled()) return;

	const cat = sanitizeInsightSegment(category);
	const name = sanitizeInsightSegment(slug);
	if (!cat || !name) return;

	try {
		const path = `/__insights/${encodeURIComponent(cat)}/${encodeURIComponent(
			name,
		)}`;
		const url =
			window.location.origin + path + "?_=" + encodeURIComponent(Date.now());

		const p = fetch(url, {
			method: "GET",
			cache: "no-store",
			mode: "same-origin",
			credentials: "omit",
			keepalive: true,
		});
		void p.catch(() => {
			const img = new Image();
			img.decoding = "async";
			img.referrerPolicy = "no-referrer";
			img.src = url + "&fallback=img";
		});
	} catch (_) {
		try {
			const img = new Image();
			img.src =
				window.location.origin +
				`/__insights/${encodeURIComponent(cat)}/${encodeURIComponent(
					name,
				)}?_=${encodeURIComponent(Date.now())}`;
		} catch (_) {}
	}
}
